import packageInfo from "../package.json";

export const APP_VERSION = packageInfo.version;
export const APP_VERSION_META_NAME = "tms-app-version";
